enum TAX_FORM_STATUSES_ENUM {
	CREATED = 'created',
	SIGNED = 'signed',
	FAILED = 'failed',
	VERIFIED = 'verified',
	EXPIRED = 'expired',
}

export default TAX_FORM_STATUSES_ENUM;
